import { render, staticRenderFns } from "./SettingsShareToken.vue?vue&type=template&id=34bb420c&scoped=true"
import script from "./SettingsShareToken.vue?vue&type=script&lang=js"
export * from "./SettingsShareToken.vue?vue&type=script&lang=js"
import style0 from "./SettingsShareToken.vue?vue&type=style&index=0&id=34bb420c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bb420c",
  null
  
)

export default component.exports